import axiosInstance from '../../../../common/axios.service';
import type {ADD_BATTERY_CATEGORY, UPDATE_BATTERY_CATEGORY} from './batteryCategory.type';
import type FILTERS from '../../../../common/filters.type';

const batteryCategoriesList = (values: FILTERS) => {
  return axiosInstance.get('batterycategory/', {params: values}).then((response) => {
    return response;
  });
};

const addBatteryCategory = (values: ADD_BATTERY_CATEGORY) => {
  return axiosInstance.post('batterycategory/', values).then((response) => {
    return response;
  });
};

const updateBatteryCategory = (values: {payload: UPDATE_BATTERY_CATEGORY; category_id: number}) => {
  return axiosInstance
    .put(`batterycategory/${values.category_id}`, values.payload)
    .then((response) => {
      return response;
    });
};

const batteryCategoryServices = {
  batteryCategoriesList,
  addBatteryCategory,
  updateBatteryCategory,
};

export default batteryCategoryServices;
